var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 27 46",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "statue",
    transform: "translate(-77.944)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1_15_",
    transform: "translate(77.944 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_306655656",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10007",
    "data-name": "Group 10007",
    transform: "translate(0.012 17.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_306656760",
    d: "M91.533,161.681c-6.1,0-11.139-2.211-12.843-5.634a4.257,4.257,0,0,1-.492-3.285c.486-1.44,2.024-2.171,3.511-2.877.3-.142.607-.288.9-.438.184-.094.68-.313,1.308-.592.9-.4,2.541-1.126,2.887-1.341a1.172,1.172,0,0,0,.092-.6.5.5,0,0,1,0-.067v-2.7a.474.474,0,1,1,.947,0v2.671a2.048,2.048,0,0,1-.295,1.307c-.132.189-.327.321-3.251,1.617-.591.262-1.1.488-1.263.57-.305.155-.62.3-.924.449-1.368.649-2.66,1.263-3.014,2.315a3.362,3.362,0,0,0,.441,2.529c1.544,3.1,6.254,5.105,12,5.105s10.455-2,12-5.105a3.36,3.36,0,0,0,.44-2.529c-.355-1.051-1.647-1.665-3.014-2.315-.3-.145-.619-.294-.924-.449-.162-.082-.672-.308-1.263-.57-2.924-1.3-3.119-1.427-3.251-1.617a2.049,2.049,0,0,1-.295-1.307v-2.671a.474.474,0,1,1,.947,0v2.7a.523.523,0,0,1,0,.067,1.16,1.16,0,0,0,.092.6c.346.214,1.987.942,2.887,1.341.628.278,1.124.5,1.308.592.294.149.6.3.9.438,1.487.706,3.024,1.437,3.511,2.877a4.258,4.258,0,0,1-.492,3.285C102.671,159.469,97.63,161.681,91.533,161.681Z",
    transform: "translate(-78.045 -143.665)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10008",
    "data-name": "Group 10008",
    transform: "translate(4.965 20.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_306656232",
    d: "M136.138,186.467a.484.484,0,0,1-.078-.962c3.95-.654,6.964-2.28,8.27-4.462a.484.484,0,1,1,.831.5c-1.474,2.462-4.65,4.209-8.943,4.92A.481.481,0,0,1,136.138,186.467ZM124.5,174.95a.484.484,0,0,1-.193-.928l.163-.071.936-.407c1.413-.618,1.864-.845,2-.928a.635.635,0,0,0,.036-.079.484.484,0,1,1,.906.342,1.533,1.533,0,0,1-.185.35c-.1.145-.172.241-2.372,1.2l-.939.408-.163.071A.484.484,0,0,1,124.5,174.95Z",
    transform: "translate(-124.017 -172.223)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10009",
    "data-name": "Group 10009",
    transform: "translate(7.287 8.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_306656496",
    d: "M146.877,85.7a6.22,6.22,0,0,1-6.213-6.213V74.921a.484.484,0,1,1,.968,0v4.561a5.245,5.245,0,1,0,10.49,0V74.921a.484.484,0,1,1,.968,0v4.561A6.221,6.221,0,0,1,146.877,85.7Z",
    transform: "translate(-140.664 -74.437)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10010",
    "data-name": "Group 10010",
    transform: "translate(3.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_306656448",
    d: "M126.89,13.713h-.953a.484.484,0,0,1,0-.968h.953a1.622,1.622,0,0,0,.569-3.117.486.486,0,0,1-.294-.514.477.477,0,0,1,.412-.418,1.617,1.617,0,0,0-.179-3.217,1.517,1.517,0,0,0-.553.1.459.459,0,0,1-.5-.117.5.5,0,0,1-.094-.524,1.647,1.647,0,0,0,.123-.628A1.591,1.591,0,0,0,124.806,2.7a1.539,1.539,0,0,0-1.224.61.461.461,0,0,1-.5.164.48.48,0,0,1-.336-.413,2.272,2.272,0,0,0-4.536.256,2.443,2.443,0,0,0,.016.276.484.484,0,0,1-.339.523.464.464,0,0,1-.553-.264,1.566,1.566,0,0,0-1.422-.942,1.591,1.591,0,0,0-1.563,1.614,1.65,1.65,0,0,0,.116.611.5.5,0,0,1-.093.516.459.459,0,0,1-.493.126,1.514,1.514,0,0,0-.507-.087,1.618,1.618,0,0,0-.2,3.214.475.475,0,0,1,.4.37.492.492,0,0,1-.2.514,1.626,1.626,0,0,0-.7,1.345,1.591,1.591,0,0,0,1.563,1.614h.6a.484.484,0,0,1,0,.968h-.6a2.546,2.546,0,0,1-2.5-2.582,2.634,2.634,0,0,1,.489-1.535A2.6,2.6,0,0,1,110.872,7.3a2.546,2.546,0,0,1,2.5-2.582h.046c0-.066-.007-.132-.007-.2a2.546,2.546,0,0,1,2.5-2.582,2.452,2.452,0,0,1,1.474.5,3.185,3.185,0,0,1,6.1-.32,2.434,2.434,0,0,1,1.321-.388,2.546,2.546,0,0,1,2.5,2.582q0,.1-.007.2l.1,0a2.546,2.546,0,0,1,2.5,2.582,2.6,2.6,0,0,1-1.227,2.223,2.613,2.613,0,0,1,.719,1.815,2.545,2.545,0,0,1-2.5,2.582Z",
    transform: "translate(-110.872 0)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10011",
    "data-name": "Group 10011",
    transform: "translate(9.045 6.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_306656592",
    d: "M163.613,56.219a.485.485,0,0,1-.155-.026,11.528,11.528,0,0,0-7.632,0,.484.484,0,0,1-.31-.918,12.461,12.461,0,0,1,8.251,0,.484.484,0,0,1-.155.943Z",
    transform: "translate(-155.187 -54.573)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10012",
    "data-name": "Group 10012",
    transform: "translate(4.965 20.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_306656856",
    d: "M135.854,188.454a.5.5,0,0,1-.114-.013c-6.2-1.492-9.989-4.512-11.26-8.978a12.781,12.781,0,0,1-.463-3.039.484.484,0,1,1,.968-.034,11.81,11.81,0,0,0,.427,2.809c1.167,4.1,4.719,6.9,10.555,8.3a.484.484,0,0,1-.113.955Zm8.564-4.243a.489.489,0,0,1-.123-.016c-5.952-1.562-10.548-3.46-13.661-5.642-2.465-1.728-3.175-3.076-3.334-3.448a.484.484,0,1,1,.89-.381,8.408,8.408,0,0,0,3,3.035c3.019,2.116,7.511,3.965,13.351,5.5a.484.484,0,0,1-.122.953Z",
    transform: "translate(-124.017 -174.431)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10013",
    "data-name": "Group 10013",
    transform: "translate(7.868 33.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_306656256",
    d: "M156.249,286.2a.484.484,0,0,1-.484-.484v-5.382a.484.484,0,0,1,.968,0v5.382A.484.484,0,0,1,156.249,286.2Zm-10.294,0a.484.484,0,0,1-.484-.484v-5.381a.484.484,0,0,1,.968,0v5.381A.484.484,0,0,1,145.954,286.2Z",
    transform: "translate(-145.47 -279.85)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10014",
    "data-name": "Group 10014",
    transform: "translate(0 38.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_306655344",
    d: "M104.47,331.533H78.418a.479.479,0,0,1-.473-.484v-3.127a3.576,3.576,0,0,1,3.532-3.612h19.937a3.576,3.576,0,0,1,3.532,3.612v3.127A.479.479,0,0,1,104.47,331.533Zm-25.579-.968H104v-2.643a2.617,2.617,0,0,0-2.585-2.643H81.475a2.617,2.617,0,0,0-2.585,2.643Z",
    transform: "translate(-77.944 -324.31)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10015",
    "data-name": "Group 10015",
    transform: "translate(6.48 21.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_306656088",
    d: "M139.538,190.753a.484.484,0,0,1-.219-.053c-4.033-2.05-6.09-7.029-6.176-7.24a.484.484,0,0,1,.9-.364c.02.048,2.011,4.857,5.717,6.741a.484.484,0,0,1-.22.916Z",
    transform: "translate(-133.108 -182.794)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10016",
    "data-name": "Group 10016",
    transform: "translate(14.415 18.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_306655944",
    d: "M200.378,159.57a.484.484,0,0,1-.468-.61l.682-2.534a.484.484,0,1,1,.935.252l-.682,2.534A.484.484,0,0,1,200.378,159.57Z",
    transform: "translate(-199.894 -156.067)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10017",
    "data-name": "Group 10017",
    transform: "translate(10.939 18.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_306655728",
    d: "M171.654,159.569a.484.484,0,0,1-.467-.358l-.682-2.534a.484.484,0,1,1,.935-.252l.682,2.534a.484.484,0,0,1-.468.61Z",
    transform: "translate(-170.489 -156.067)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10018",
    "data-name": "Group 10018",
    transform: "translate(13.071 20.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_306656040",
    d: "M188.939,175.186a.484.484,0,0,1-.484-.484v-1.466a.484.484,0,0,1,.968,0V174.7A.484.484,0,0,1,188.939,175.186Z",
    transform: "translate(-188.455 -172.752)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10019",
    "data-name": "Group 10019",
    transform: "translate(15.536 25.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_306655680",
    d: "M218.722,213.317a.481.481,0,0,1-.242-.065,5.811,5.811,0,0,0-6.372-.034.484.484,0,0,1-.587-.771,6.756,6.756,0,0,1,7.442-.034.484.484,0,0,1-.242.9Z",
    transform: "translate(-211.333 -211.331)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10020",
    "data-name": "Group 10020",
    transform: "translate(3.44 25.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_306655920",
    d: "M106.848,213.133a.484.484,0,0,1-.3-.866,6.117,6.117,0,0,1,2.831-1.059.484.484,0,1,1,.118.961,5.164,5.164,0,0,0-2.354.862A.483.483,0,0,1,106.848,213.133Z",
    transform: "translate(-106.363 -211.204)",
    fillRule: "evenodd"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIType);
export default __webpack_public_path__ + "static/media/i-type.937c089af9b026c7708e69094ce1bbdf.svg";
export { ForwardRef as ReactComponent };